import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiRadio: Components<Theme>['MuiRadio'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      color: scssVariables.ColorBlack60,
      '&.Mui-checked': {
        color: scssVariables.ColorBlue80,
        'span::before': {
          content: '""',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '16px',
          height: '16px',
          borderRadius: '50%',
          backgroundColor: scssVariables.ColorBlue20,
        },
      },
      '.MuiSvgIcon-root': {
        width: '20px',
        height: '20px',
      },
    },
  },
  variants: [
    {
      props: { size: 'small' },
      style: {
        width: 'var(--input-height-small)',
        height: 'var(--input-height-small)',
        '.MuiSvgIcon-root': {
          width: '16px',
          height: '16px',
        },
      },
    },
    {
      props: { size: 'medium' },
      style: {
        width: 'var(--input-height-medium)',
        height: 'var(--input-height-medium)',
        '.MuiSvgIcon-root': {
          width: '18px',
          height: '18px',
        },
      },
    },
  ],
};
